__turbopack_context__.v({
  "bounce": "styles-module-scss-module__5MLSUG__bounce",
  "container": "styles-module-scss-module__5MLSUG__container",
});
